const TEXT_INPUT_TYPES = new Set([
  "text",
  "email",
  "password",
  "search",
  "tel",
  "url",
  "number",
  "date",
  "time",
  "datetime-local",
  "month",
  "week",
]);

function isTextInput(el: Element): boolean {
  if (el instanceof HTMLTextAreaElement) return true;
  if (el instanceof HTMLInputElement) return TEXT_INPUT_TYPES.has(el.type);
  if (el instanceof HTMLElement && el.isContentEditable) return true;
  return false;
}

function isTextInputFocused(): boolean {
  const active = document.activeElement;
  return active instanceof Element && isTextInput(active);
}

export { isTextInput, isTextInputFocused };
